"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import PrivacyNotice from "~/components/job-page/jobadtemplate/privacy-notice-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
function getIntroductionText(entryLevel?: string, company?: string): string {
  if (entryLevel === "Entry Level") {
    return "Our early careers opportunities offer the chance to work full-time, gain hands-on experience, and grow into your full potential. All of this while earning a competitive salary and completing a recognised qualification. With us, you'll be able to build a brighter future for yourself and make a real difference for others.";
  }
  if (company === "Npower Business Solutions") {
    return "At npower Business Solutions (nBS), part of E.ON’s UK Industrial & Commercial division, we work with businesses every day to help them use energy more sustainably. With 60,000 customers and growing, we’re on a journey to create a better energy future together.";
  }
  return "Join one of the UK’s leading energy companies and be part of something bigger. We’re transforming the future of energy and the way we work. Flexible, inclusive, and driven by purpose, this is a place where you can make a real difference and build a career you’re proud of.";
}
export default function JobAdTemplateEonUk(t0) {
  const $ = _c(26);
  const {
    job
  } = t0;
  const t = useLanguage();
  const data = job.data;
  let t1;
  if ($[0] !== data.company || $[1] !== data.entryLevel) {
    const introText = getIntroductionText(data.entryLevel, data.company);
    const paragraphs = introText.split("\n\n");
    t1 = paragraphs.map((paragraph, index) => <span key={index}>{paragraph}{index < paragraphs.length - 1 && <><br /><br /></>}</span>);
    $[0] = data.company;
    $[1] = data.entryLevel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = t1;
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="mb-6 lg:grid lg:grid-cols-[minmax(0,1fr)_400px]"><p data-source="job">{t2}</p></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data.title) {
    t4 = <h2 className="mb-4 font-bold text-4xl text-primary md:text-5xl" data-source="job">{data.title}</h2>;
    $[5] = data.title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t.jobad_description_HL) {
    t5 = <h3 className="sr-only" data-source="lc">{t.jobad_description_HL}</h3>;
    $[7] = t.jobad_description_HL;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== job.content.offer) {
    t6 = job.content.offer && <div className="mt-6"><h3 className="font-bold" data-source="job">Here's what you'll be doing</h3><div dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} data-source="job" /></div>;
    $[9] = job.content.offer;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== job.content.task) {
    t7 = job.content.task && <div className="mt-6"><h3 className="font-bold" data-source="job">Main responsibilities of the role</h3><div dangerouslySetInnerHTML={{
        __html: job.content.task
      }} data-source="job" /></div>;
    $[11] = job.content.task;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== job.content.profile) {
    t8 = job.content.profile && <div className="mt-6"><h3 className="font-bold" data-source="job">What we need from you</h3><div dangerouslySetInnerHTML={{
        __html: job.content.profile
      }} data-source="job" /></div>;
    $[13] = job.content.profile;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t10;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-6 bg-gray-200 p-4"><p data-source="text">At E.ON, we're committed to building a diverse, inclusive, and respectful workplace where everyone can thrive. However you identify, and whatever your background, we welcome your application. We value the unique perspectives that each individual brings - because a sustainable future needs all of us. We aim to make our recruitment process accessible to all. Visit our{" "}<CustomLink blank={true} className="font-medium text-primary underline" href="https://www.eon-uk-careers.com/en/job-search/application-support.html">Application Support</CustomLink>{" "}page if you need adjustments or support.</p></div>;
    t10 = <PrivacyNotice className="mt-6" />;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t11 = <div className="**:list-disc lg:grid lg:grid-cols-[minmax(0,1fr)_400px] [&_ul]:ml-4"><div>{t5}{t6}{t7}{t8}{t9}{t10}</div></div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t3 || $[24] !== t4) {
    t12 = <section className="outer-container py-10 lg:text-lg print:hidden" id="job"><div className="inner-container">{t3}{t4}{t11}</div></section>;
    $[22] = t11;
    $[23] = t3;
    $[24] = t4;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}